import React from "react";
import "./Projects.css";
import img0 from '../../assets/techxillencce.png'
import img from '../../assets/todo.png'
import img1 from '../../assets/cdrskillassessment.png'
import img2 from '../../assets/port.png'
import img3 from '../../assets/bootcamp.png'
import img4 from '../../assets/GharBhada.png'
import img5 from '../../assets/engin.png'
import img6 from '../../assets/ang.png'
import img7 from '../../assets/react-admin-dashboard.png'
import img8 from '../../assets/portfolio-v3.png'
import { FaReact, FaAngular, FaSass } from "react-icons/fa";
import {
  SiHtml5,
  SiExpress,
  SiMongodb,
  SiNodedotjs,
  SiNextdotjs,
  SiStrapi,
  SiJavascript
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { BsBootstrap } from "react-icons/bs";
import { IoLogoJavascript } from "react-icons/io";
export const Projects = () => {
  return (
    <>
      <div className="section">
        <h2 className="section__title different">Projects</h2>
        <div className="allProjects">
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src={img8}
                    alt="Portfolio-v3"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Portfolio v3</h2>
                <p>
                A better version of Portfolio-v2 (Under Progress)
                </p>
                <div>
                  <FaReact />
                  <DiCss3 />
                  <SiHtml5 />
                  <FaSass />
                  <SiJavascript />
                </div>
                <div>
                  <a
                    href="https://portfolio-v3-eight-psi.vercel.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src={img7}
                    alt="AdminDashboard"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Admin Dashboard</h2>
                <p>
                Redeveloped a clone.
                </p>
                <div>
                  <FaReact />
                  <DiCss3 />
                  <SiHtml5 />
                  <FaSass />
                  <SiJavascript />
                </div>
                <div>
                  <a
                    href="https://react-admin-dashboard-ten-sepia.vercel.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src={img0}
                    alt="Techxillence"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Tegzy</h2>
                <p>
                Developed previous company's website.
                </p>
                <div>
                  <SiNextdotjs/>
                  <FaReact />
                  <DiCss3 />
                  <SiHtml5 />
                  <BsBootstrap />
                  <SiStrapi />
                  <FaSass />
                </div>
                <div>
                  <a
                    href="https://www.tegzy.com.au/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src={img}
                    alt="Todo List"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Todo List</h2>
                <p>
                CRUD operation, save a photo of your list functionality, with minimalist design.
                </p>
                <div>
                  <FaReact />
                  <DiCss3 />
                  <SiHtml5 />
                  <BsBootstrap />
                </div>
                <div>
                  <a
                    href="https://sherchanstrikes.github.io/Todo-List/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src={img6}
                    alt="Todo List"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Todo List in Angular Js</h2>
                <p>
                Simple TodoList
                </p>
                <div>
                  <DiCss3 />
                  <SiHtml5 />
                  <BsBootstrap />
                  <FaAngular />
                </div>
                <div>
                  <a
                    href="https://todo-plan-hazel.vercel.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src={img1}
                    alt="Cdrskillassessment"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Cdrskillassessment</h2>
                <p>
                  Rebuilt a client's website in Tegzy.
                </p>
                <div>
                  <SiNextdotjs/>
                  <DiCss3 />
                  <SiHtml5 />
                  <FaReact />
                  <BsBootstrap />
                  <SiStrapi />
                </div>
                <div>
                  <a
                    href="https://www.cdrskillassessment.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      See this Live
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src={img5}
                    alt="CdrForEngineer"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>CdrForEngineer</h2>
                <p>
                  Rebuilt a client's website in Tegzy.
                </p>
                <div>
                  <SiNextdotjs/>
                  <DiCss3 />
                  <SiHtml5 />
                  <FaReact />
                  <BsBootstrap />
                  <SiStrapi />
                </div>
                <div>
                  <a
                    href="https://www.cdrforengineer.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      See this Live
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img src={img2} alt="Portfolio" />
                </div>
              </div>
              <div className="project_information">
                <h2>Portfolio v1</h2>
                <p>
                  First Portfolio I made.
                </p>
                <div>
                <DiCss3 />
                  <SiHtml5 />
                  <IoLogoJavascript />
                  <FaReact />
                  <BsBootstrap />
                </div>
                <div>
                  <a
                    href="https://sherchanstrikes.github.io/portfolio/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      See this Live
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src={img3}
                    alt="bootcamp"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Frontend Bootcamp</h2>
                <p>
                 Clone Website.
                </p>
                <div>
                <DiCss3 />
                  <SiHtml5 />
                  <IoLogoJavascript />
                  <BsBootstrap />
                </div>
                <div>
                <a
                    href="https://sherchanstrikes.github.io/Bootstrap_Website/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      See this Live
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src={img4}
                    alt="GharBhada"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>GharBhada v2</h2>
                <p>
                  Redeveloping GharBhada v1 - Ongoing
                </p>
                <div>
                  <SiNodedotjs />
                  <SiExpress />
                  <SiMongodb />
                  <SiHtml5 />
                  <DiCss3 />
                  <FaReact />
                  <BsBootstrap />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};
